"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREMIUM_IMAGE_BANNER_CHAR_LIMIT = exports.PREMIUM_DUPLEX_DESC_CHAR_LIMIT = exports.DESC_CHAR_LIMIT = exports.TITLE_CHAR_LIMIT = exports.MOCK_ESI_LOGO_IMAGE_URL = exports.MOCK_ESI_DESKTOP_IMAGE_URL = exports.MOCK_ESI_TABLET_IMAGE_URL = exports.MOCK_ESI_MOBILE_IMAGE_URL = exports.ENV_BUCKET = exports.ENV_DOMAIN = exports.JLP_STYLES = exports.ASSET_PREFIX_UPPER_TIER = exports.ASSET_PREFIX_STUBS = exports.MOCK_API_URL = exports.BANNER_PREVIEWER_DATA_ELEM_ID = exports.BANNER_PREVIEWER_ROOT_ELEM_ID = exports.BANNER_DATA_ELEM_ID = exports.BANNER_ROOT_ELEM_ID = exports.INTEGRATION_ENV = exports.DEVELOPMENT_ENV = exports.PRODUCTION_ENV = exports.STUBS_ENV = exports.TEST_ENV = void 0;
// ENVIRONMENT
exports.TEST_ENV = "test";
exports.STUBS_ENV = "stubs";
exports.PRODUCTION_ENV = "production";
exports.DEVELOPMENT_ENV = "development";
exports.INTEGRATION_ENV = "integration";
// DOM ELEMENTS
exports.BANNER_ROOT_ELEM_ID = "online-ads-banner-esi";
exports.BANNER_DATA_ELEM_ID = "__ONLINE_ADS_BANNER_DATA__";
exports.BANNER_PREVIEWER_ROOT_ELEM_ID = "banner-previewer";
exports.BANNER_PREVIEWER_DATA_ELEM_ID = "__BANNER_PREVIEWER_DATA__";
// API SERVICE
exports.MOCK_API_URL = "http://localhost:3000/api";
// ASSET PREFIX
exports.ASSET_PREFIX_STUBS = "/static/";
exports.ASSET_PREFIX_UPPER_TIER = "/static/bucket/adtech-banner-esi-assets/";
// JLP ASSETS
exports.JLP_STYLES = "https://www.integration.project4.com/static/ui-assets/css/jlp-styles-6.css";
exports.ENV_DOMAIN = {
    production: "https://www.johnlewis.com",
    integration: "https://www.integration.project4.com",
    stubs: "https://stubs-adtech-banner-esi.online-adverts.flex.jl-digital.net",
};
// Only used by the Server-Side previewer
exports.ENV_BUCKET = {
    production: "https://storage.googleapis.com/jl-adtech-banner-esi-assets-prod",
    integration: "https://storage.googleapis.com/jl-adtech-banner-esi-assets-integration",
    stubs: "https://storage.googleapis.com/jl-adtech-banner-esi-assets-stubs",
};
// ESI STUBS IMAGES
exports.MOCK_ESI_MOBILE_IMAGE_URL = "https://storage.googleapis.com/jl-adtech-banner-esi-assets-stubs/assets/esi/768x689.jpeg";
exports.MOCK_ESI_TABLET_IMAGE_URL = "https://storage.googleapis.com/jl-adtech-banner-esi-assets-stubs/assets/esi/640x320.jpeg";
exports.MOCK_ESI_DESKTOP_IMAGE_URL = "https://storage.googleapis.com/jl-adtech-banner-esi-assets-stubs/assets/esi/1024x468.png";
exports.MOCK_ESI_LOGO_IMAGE_URL = "https://storage.googleapis.com/jl-adtech-banner-esi-assets-stubs/assets/esi/296x60.png";
// BANNER_CHAR_LIMITS
exports.TITLE_CHAR_LIMIT = 35;
exports.DESC_CHAR_LIMIT = 100;
exports.PREMIUM_DUPLEX_DESC_CHAR_LIMIT = 102;
exports.PREMIUM_IMAGE_BANNER_CHAR_LIMIT = 40;
